import { __awaiter, __generator } from "tslib";
import { LogLevel } from '../interfaces';
import { deepCopy } from '../utils';
/**
 * MessageProcessor for processing the message requests which involves :
 * Routing message requests to proper handler
 * Posting response back to the app
 */
var BaseMessageProcessor = /** @class */ (function () {
    /**
     * Registers different available handlers
     */
    function BaseMessageProcessor(appSdkHost) {
        this.appSdkHost = appSdkHost;
        this.messageHandlers = [];
        this.TAG = 'BaseMessageProcessor';
    }
    /**
     * Responsible for processing of message requests from MetaOS App
     */
    BaseMessageProcessor.prototype.process = function (event) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var message, requestArgs, result, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        message = event.data;
                        requestArgs = message.args;
                        // We need to prepend it so we can guarantee the index.
                        // We need to make a deep copy of the args before altering it since the message event is reused across listeners.
                        requestArgs = message.args && Array.isArray(message.args) ? message.args.map(function (arg) { return deepCopy(arg); }) : [];
                        requestArgs.unshift(event);
                        return [4 /*yield*/, this.callMessageHandler(message.func, requestArgs, message.timestamp)];
                    case 1:
                        result = _b.sent();
                        if (result.kind === 'appResponse') {
                            this.processHandlerResultHelper(message, result);
                            this.appSdkHost.getLogger().log(LogLevel.Info, this.TAG, "Function name: ".concat(event.data.func));
                            return [2 /*return*/, Promise.resolve(true)];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        this.appSdkHost
                            .getLogger()
                            .log(LogLevel.Error, this.TAG, "Error in processing request: ".concat((_a = event.data) === null || _a === void 0 ? void 0 : _a.func), err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, Promise.resolve(false)];
                }
            });
        });
    };
    BaseMessageProcessor.prototype.callMessageHandler = function (message, args, clientTimestamp) {
        for (var _i = 0, _a = this.messageHandlers; _i < _a.length; _i++) {
            var handler = _a[_i];
            if (handler.canHandleMessage(message)) {
                return handler.handleMessage(message, args, clientTimestamp);
            }
        }
        return Promise.reject('Unhandled message');
    };
    /**
     * Responsible for posting the response back to the App
     */
    BaseMessageProcessor.prototype.processHandlerResultHelper = function (message, response) {
        var messageId = message.id;
        var responseArgs = [];
        if (response.data) {
            responseArgs = Array.isArray(response.data) ? response.data : [response.data];
        }
        this.appSdkHost.postResponseToApp(messageId, responseArgs);
    };
    BaseMessageProcessor.prototype.cleanup = function () {
        this.messageHandlers.forEach(function (mh) { return mh.cleanup(); });
    };
    return BaseMessageProcessor;
}());
export { BaseMessageProcessor };
//# sourceMappingURL=base-message-processor.js.map